export function simulatorEventsHref(simulator) {
  const slug = String(simulator?.slug || simulator?.id || "").trim();
  return slug ? `/eventos/simulador/${encodeURIComponent(slug)}` : "/eventos";
}

export function normalizeSimulatorSlug(value) {
  return String(value || "").trim().toLowerCase();
}

export function simulatorNameFromSlug(slug) {
  return SIMULATOR_NAMES[normalizeSimulatorSlug(slug)] || "";
}

export function simulatorSeoDescription(slug) {
  const name = simulatorNameFromSlug(slug);
  return name
    ? `Encuentra eventos, carreras sueltas, torneos y campeonatos de ${name} en Nitro Simracing Colombia. Horarios, requisitos e inscripciones para pilotos de simracing.`
    : "Encuentra eventos, carreras sueltas, torneos y campeonatos de simracing en Nitro Simracing Colombia.";
}

export function simulatorEventRoutes() {
  return Object.keys(SIMULATOR_NAMES).map((slug) => ({
    slug,
    name: SIMULATOR_NAMES[slug],
    href: simulatorEventsHref({ slug }),
  }));
}

export const SIMULATOR_NAMES = {
  "assetto-corsa-competizione-pc": "Assetto Corsa Competizione",
  "assetto-corsa-pc": "Assetto Corsa",
  "automobilista-2": "Automobilista 2",
  "dirt-rally-2-0": "Dirt Rally 2.0",
  "ea-wrc": "EA WRC",
  "euro-truck-american-truck-simulator": "Euro Truck / American Truck Simulator",
  "f125": "F1 25",
  "gran-turismo-7": "Gran Turismo 7",
  "iracing": "iRacing",
  "le-mans-ultimate": "Le Mans Ultimate",
  "rfactor2": "rFactor2",
};
